import global from "./global.js";
import Style from "./utils/Style.js";
import TheUser from "./users/TheUser.js";

const log = global.log.getLogger("f_mtac.users");
log.setLevel(log.levels.WARN);

const CAP_GEO = 1 << 0,
    CAP_GEO_POS = 1 << 1;

/**
 * @brief Handle the HTML node of a user in the User list
 * @param {*} login
 * @param {*} name
 * @param {*} capabilities
 * @param {*} style
 */
const User = function (login, name, capabilities, style) {
    const display_capabilities = () => {
        if (capabilities & CAP_GEO && capabilities & CAP_GEO_POS) {
            style.rule_set(login, `g.resource[data-user="${login}"] circle.user_name { fill: #0f0; }`);
        } else {
            style.rule_set(login, `g.resource[data-user="${login}"] circle.user_name { fill: #f00; }`);
        }
    };
    display_capabilities();

    const update_name_in_select_list = () => $(`#select-user option[value="${login}"]`)?.text(name);

    Object.defineProperty(this, "name", {
        set: (new_name) => {
            name = new_name;
            update_name_in_select_list();
        },
        get: () => name
    });

    Object.defineProperty(this, "capabilities", {
        set: (new_capabilities) => {
            capabilities = new_capabilities;
            display_capabilities();
        },
        get: () => capabilities
    });

    Object.defineProperty(this, "login", {
        set: () => {},
        get: () => login
    });

    this.remove = () => {
        log.debug(`User.remove login = ${login}`);
        $(`#select-user option[value="${login}"]`).remove();
        style.rule_unset(login);
    };

    this.refresh_capabilities = () => {
        log.debug("refresh_capabilities ", capabilities);
        display_capabilities();
    };
};

/* 
 * This class is responsible for the display of the list of users sharing the room
 *I there is no sharing, the current user is displayed
**/
const UsersList = function () {
    var map = {};
    /*Object.defineProperty(this, "map", {
        set: () => {},
        get: () => map
    });*/

    this.get = (login) => {
        log.debug(`UsersList.get login = ${login}`);
        if (!(login in map)) {
            return null;
        }
        return map[login];
    };

    this.unset = (login) => {
        log.debug(`UsersList.unset login = ${login}`);
        var user = this.get(login);
        if (user === null) {
            return;
        }
        delete map[login];
        user.remove();
    };

    this.unset_all = () => {
        log.debug("UsersList.unset_all");
        $("#select-user").empty();
        map = {};

    };

    this.set = (login, name, capabilities, style) => {
        log.debug(`UsersList.set login = ${login}, name = ${name}`);
        var user = this.get(login);
        if (user !== null) {
            user.name = name;
            user.capabilities = capabilities;
            return;
        }
        user = new User(login, name, capabilities, style);
        map[login] = user;
        // Add the user into the select of user_list_area
        const opt = document.createElement("option");
        opt.value = login;
        opt.innerHTML = name;
        document.getElementById("select-user")?.appendChild(opt);
    };
};

/**
 * This class is responsible for the list of 
 * connected users 
 */
const Users = function () {
    //var space = null;    
    var users = new UsersList();
    var style = new Style();

    style.rule_set_top("default", "g.resource circle.user_name { fill: #f00; }");

    const user_update_name = (login, name, capabilities) => {
        log.debug(`Users.user_update_name login = ${login}, name = ${name}, capabilities = ${capabilities}`);
        var user = users.get(login);
        if (user !== null) {
            log.debug("Users.user_update_name login found, update user");
            user.name = name;
            user.capabilities = capabilities;
            return;
        }
        log.debug("Users.user_update_name login not found, add user");
        users.set(login, name, capabilities, style);
    };
    this.user_update_name = user_update_name;

    const user_remove = (login) => {
        log.debug(`Users.user_remove login = ${login}`);
        users.unset(login);
    };

    this.unset_users = () => {
        users.unset_all();
        style.rule_unset_all();
    };
    
    const self_update = () => {
        let {login, name, capabilities} = global.server.registrar.user;
        log.debug(`Users.self_update login = ${login}`);
        if (login === undefined) {
            return;
        }
        user_update_name(login, name, capabilities);
    };

    // Callback on space change: update users list
    global.event_bus.subscribe("storage.space.changed", async ({old_space, new_space}) => {
        log.debug("Users -> on storage.space.changed", {old_space, new_space});
        
        if (old_space !== null) {
            global.users.unset_users();
        }
        if (new_space !== null) {
            await this.sync();
        }
    });

    /**
     * Synchronize user list with server info
     * @returns 
     */
    this.sync = async () => {
        log.debug("Users.sync in");
        let space = global.storage.selected_space;
        if (space === null || space.room === null) {
            self_update();
            log.debug("Users.sync out");
            return;
        }
        try {
            log.debug("Users.sync before mtac_room_users");
            let response = await global.server.mtac_room_users(space.room);
            var users_list = response.data.list;
            log.debug("Users.sync users_list", users_list);
        } catch (error) {
            log.error("Users error while fetching user list", error);
            self_update();
            return;
        }
        var local_logins = [...document.querySelectorAll("#select-user option")].map((user) => user.value);
        log.debug("Users.sync local_logins", local_logins);
        for (let login in users_list) {
            let {name, capabilities} = users_list[login];
            user_update_name(login, name, capabilities);
            let login_index = local_logins.indexOf(login);
            if (login_index !== -1) {
                local_logins.splice(login_index, 1);
            }
        }
        for (let login of local_logins) {
            user_remove(login);
        }
        self_update();
    };

    this.get_agnet_user_name = () => {
        let name = global.internationalization.text("user.Unknown");
        if (global.configuration.user.first_name != undefined) {
            name = global.configuration.user.first_name;
            if (global.configuration.user.last_name != undefined) {
                name += " " + global.configuration.user.last_name;
            }
        } else {
            // first name undefined
            if (global.configuration.user.last_name != undefined) {
                name = global.configuration.user.last_name;
            }
        }
        return name;
    };
};


global.app.bootstrap.register_module({
    name: "users",
    deps: ["geolocation"],
    init: () => {
        global.users = new Users();
        global.theUser = new TheUser();
        global.theUser.init();
    }
});

export default Users;
